import { ChatComposeBoxAddAttachmentMenuItem } from '@glade-ai/chat-plugin/ui';
import { useRouter } from 'next/router';
import { type ComponentPropsWithoutRef, forwardRef, useCallback } from 'react';

import { mixpanelTrack } from '@/providers/Mixpanel';
import { useScreenRecord } from '@/providers/ScreenRecord';

const ADD_SCREEN_RECORD_LABEL = 'Record Screen';
const ADD_SCREEN_RECORD_ICON = 'ph--monitor-arrow-up--regular';

/** Attachment menu item that starts a screen recording. Secondary entry point (the global FAB is primary). */
export const AddScreenRecordMenuItem = forwardRef<
  HTMLDivElement,
  Omit<ComponentPropsWithoutRef<typeof ChatComposeBoxAddAttachmentMenuItem>, 'icon' | 'label'>
>((props, forwardedRef) => {
  const { isScreenRecordSupported, isRecording, startRecording } = useScreenRecord();
  const router = useRouter();

  const handleClick = useCallback(
    (event: React.MouseEvent<HTMLDivElement>) => {
      props.onClick?.(event);
      void startRecording().then((started) => {
        if (started) {
          mixpanelTrack('screen_recording_started', { source: 'attachment_menu', page: router.asPath });
        }
      });
    },
    [startRecording, props, router.asPath],
  );

  if (!isScreenRecordSupported || isRecording) {
    return null;
  }

  return (
    <ChatComposeBoxAddAttachmentMenuItem
      {...props}
      ref={forwardedRef}
      icon={ADD_SCREEN_RECORD_ICON}
      label={ADD_SCREEN_RECORD_LABEL}
      onClick={handleClick}
    />
  );
});
AddScreenRecordMenuItem.displayName = 'AddScreenRecordMenuItem';
